<template>
  <div>
    <iq-card v-if="organization">
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fas fa-map-marker-alt"></i>
          ADMIN CITA.IO
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="float-right mr-3" right variant="success" @click="updateOrganizationAdminCita">{{
          $t("public.components.organization.preferences.btnModify")
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <PreferencesAdminFuncionalities :organization="organization"></PreferencesAdminFuncionalities>
      </template>
    </iq-card>
    <iq-card v-if="planType && planType.type">
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fas fa-map-marker-alt"></i>
          Planes
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="float-right mr-3" right variant="success" @click="changePremiumPlanType">{{
          $t("public.components.organization.preferences.btnModify")
        }}
        </b-button>
      </template>
      <template v-if="planType && planType.type" v-slot:body>
        <b-form-group>
          <b-form-group>
            <b-form-radio-group id="radio-plan-type" v-model="planType.type">
              <b-form-radio value="FREE">
                <b-badge class="cursor-point" pill variant="success" @click="openModalPlanTypeInfo('FREE')">
                  GRATUITO
                </b-badge>
              </b-form-radio>
              <b-form-radio value="STANDARD">
                <b-badge class="cursor-point" pill variant="success" @click="openModalPlanTypeInfo('STANDARD')">
                  ÉSTANDAR
                </b-badge>
              </b-form-radio>
              <b-form-radio value="PREMIUM">
                <b-badge class="cursor-point" pill variant="success" @click="openModalPlanTypeInfo('PREMIUM')">
                  PREMIUM
                </b-badge>
              </b-form-radio>
              <b-form-radio value="ADHOC">
                <b-badge class="cursor-point" pill variant="success" @click="openModalPlanTypeInfo('ADHOC')">
                  ADHOC
                </b-badge>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-form-group>
      </template>
    </iq-card>
    <b-modal v-if="planTypeInfo" id="modal-plan-type-info-admin" centered size="lg" @ok="updatePlanType">
      <template #modal-ok>
        {{ $t("public.components.schedule.Schedule.modalCreate.btnUpdate") }}
      </template>
      <template #modal-cancel>{{
        $t("public.auth.patient.schedule.modalCreate.btnCancel")
      }}
      </template>
      <template #modal-title>{{
        $t(
              "public.components.organization.preferences.preferences.modalPlanType.title"
        )
      }}
      </template>
      <tab-nav :pills="true" class="iq-edit-profile d-flex pill-theme">
        <tab-nav-items :active="true" class="col-md-6 p-0" href="#parameters-tab">
          <template v-slot:title>
            <h4 class="card-title title-typography-color">
              <i aria-hidden="true" class="ri-file-settings-line"></i>
              Párametros
            </h4>
          </template>
        </tab-nav-items>
        <tab-nav-items :active="false" class="col-md-6 p-0" href="#funcionalities-tab">
          <template v-slot:title>
            <h4 class="card-title title-typography-color">
              <i aria-hidden="true" class="ri-sound-module-line"></i>
              Funcionalidades
            </h4>
          </template>
        </tab-nav-items>
      </tab-nav>
      <tab-content id="pills-tabContent-1">
        <tab-content-item id="parameters-tab" :active="true">
          <form action="#">
            <b-container>
              <b-row>
                <b-col cols="6">
                  <b-form-group label-for="name">
                    <template slot="label">
                      {{
                        $t(
                                            "public.components.organization.preferences.preferences.modalPlanType.name"
                        )
                      }}
                    </template>
                    <ul class="list-group">
                      <li class="list-group-item">
                        {{ planTypeInfo.name }}
                      </li>
                    </ul>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="monthlyRate">
                    <template slot="label">
                      {{
                        $t(
                                            "public.components.organization.preferences.preferences.modalPlanType.monthPrice"
                        )
                      }}:
                    </template>
                    <ul class="list-group">
                      <li class="list-group-item">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span id="inputGroupPrepend" class="input-group-text">€</span>
                          </div>
                          <b-form-input v-model="planTypeInfo.monthlyRate" type="number"></b-form-input>
                        </div>
                      </li>
                    </ul>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6">
                  <b-form-group label-for="monthlyRateMinutesMonoconferenceProfessional">
                    <template slot="label">
                      {{
                        $t(
                                            "public.components.organization.preferences.preferences.modalPlanType.videoMinsIncluded"
                        )
                      }}:
                    </template>
                    <ul class="list-group">
                      <li class="list-group-item">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span id="inputGroupPrepend" class="input-group-text">Minutos</span>
                          </div>
                          <b-form-input v-model="
                            planTypeInfo.monthlyRateMinutesMonoconferenceProfessional
                          " type="number"></b-form-input>
                        </div>
                      </li>
                    </ul>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="monthlyRateMinutesMulticonferenceProfessional">
                    <template slot="label">
                      {{
                        $t(
                                            "public.components.organization.preferences.preferences.modalPlanType.multiVideoMinsIncluded"
                        )
                      }}:
                    </template>
                    <ul class="list-group">
                      <li class="list-group-item">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span id="inputGroupPrepend" class="input-group-text">Minutos</span>
                          </div>
                          <b-form-input v-model="
                            planTypeInfo.monthlyRateMinutesMulticonferenceProfessional
                          " type="number"></b-form-input>
                        </div>
                      </li>
                    </ul>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6">
                  <b-form-group label-for="priceCallPhone">
                    <template slot="label">
                      {{
                        $t(
                                            "public.components.organization.preferences.preferences.modalPlanType.reminderCalsPrice"
                        )
                      }}:
                    </template>
                    <ul class="list-group">
                      <li class="list-group-item">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span id="inputGroupPrepend" class="input-group-text">€</span>
                          </div>
                          <b-form-input v-model="planTypeInfo.priceCallPhone" type="number"></b-form-input>
                        </div>
                      </li>
                    </ul>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <b-form-group label-for="priceMessageSms">
                    <template slot="label">
                      {{
                        $t(
                                            "public.components.organization.preferences.preferences.modalPlanType.reminderSmsPrice"
                        )
                      }}:
                    </template>
                    <ul class="list-group">
                      <li class="list-group-item">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span id="inputGroupPrepend" class="input-group-text">€</span>
                          </div>
                          <b-form-input v-model="planTypeInfo.priceMessageSms" type="number"></b-form-input>
                        </div>
                      </li>
                    </ul>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group label-for="priceMessageWhatapp">
                    <template slot="label">
                      {{
                        $t(
                                            "public.components.organization.preferences.preferences.modalPlanType.reminderWhatsPrice"
                        )
                      }}:
                    </template>
                    <ul class="list-group">
                      <li class="list-group-item">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span id="inputGroupPrepend" class="input-group-text">€</span>
                          </div>
                          <b-form-input v-model="planTypeInfo.priceMessageWhatapp" type="number"></b-form-input>
                        </div>
                      </li>
                    </ul>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group label-for="priceMinuteMonoconference">
                    <template slot="label">
                      {{
                        $t(
                                            "public.components.organization.preferences.preferences.modalPlanType.videoMinPrice"
                        )
                      }}:
                    </template>
                    <ul class="list-group">
                      <li class="list-group-item">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span id="inputGroupPrepend" class="input-group-text">€</span>
                          </div>
                          <b-form-input v-model="planTypeInfo.priceMinuteMonoconference" type="number"></b-form-input>
                        </div>
                      </li>
                    </ul>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6">
                  <b-form-group label-for="priceMinuteMulticonference">
                    <template slot="label">
                      {{
                        $t(
                                            "public.components.organization.preferences.preferences.modalPlanType.multiVideoMinPrice"
                        )
                      }}:
                    </template>
                    <ul class="list-group">
                      <li class="list-group-item">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span id="inputGroupPrepend" class="input-group-text">€</span>
                          </div>
                          <b-form-input v-model="planTypeInfo.priceMinuteMulticonference" type="number"></b-form-input>
                        </div>
                      </li>
                    </ul>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="priceMinuteRecording">
                    <template slot="label">
                      {{
                        $t(
                                            "public.components.organization.preferences.preferences.modalPlanType.recordingMinPrice"
                        )
                      }}:
                    </template>
                    <ul class="list-group">
                      <li class="list-group-item">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span id="inputGroupPrepend" class="input-group-text">€</span>
                          </div>
                          <b-form-input v-model="planTypeInfo.priceMinuteRecording" type="number"></b-form-input>
                        </div>
                      </li>
                    </ul>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </form>
        </tab-content-item>
        <tab-content-item id="funcionalities-tab" :active="false">
          <PreferencesAdminFuncionalities :organization="organizationPreferencesAdminFuncionalities">
          </PreferencesAdminFuncionalities>
        </tab-content-item>
      </tab-content>
    </b-modal>
  </div>
</template>
<script>
import { xray } from "../../config/pluginInit";

import organizationService from "../../services/organization";

import PreferencesAdminFuncionalities from "../../components/organization/PreferencesAdminFuncionalities";

export default {
  name: "OrganizationPreferenceAdmin",
  props: {
    organization: undefined,
    planType: undefined,
  },
  mounted() {
    xray.index();
    this.getPlanTypes();
  },
  methods: {
    getFuncionalities() {
      let funcionalities = [];

      if (this.organizationPreferencesAdminFuncionalities) {
        if (
          this.organizationPreferencesAdminFuncionalities.planMulticonference
        ) {
          funcionalities.push("PLAN_MULTICONFERENCE");
        }
        if(this.organizationPreferencesAdminFuncionalities.planPatientWelcome){
          funcionalities.push("PLAN_PATIENT_WELCOME");
        }
        if (this.organizationPreferencesAdminFuncionalities.planRecorded) {
          funcionalities.push("PLAN_RECORDED");
        }
        if (this.organizationPreferencesAdminFuncionalities.planSendReminderWallet) {
          funcionalities.push("PLAN_SEND_REMINDER_WALLET");
        }
        if (this.organizationPreferencesAdminFuncionalities.planSurvey) {
          funcionalities.push("PLAN_SURVEY");
        }
        if (this.organizationPreferencesAdminFuncionalities.planInteractive) {
          funcionalities.push("PLAN_INTERACTIVE");
        }
        if(this.organizationPreferencesAdminFuncionalities.planDashboardPicture){
          funcionalities.push("PLAN_DASHBOARD_PICTURE");
        }
        if (this.organizationPreferencesAdminFuncionalities.planReminders) {
          funcionalities.push("PLAN_REMINDERS");
        }
        if (this.organizationPreferencesAdminFuncionalities.planAlerts) {
          funcionalities.push("PLAN_ALERTS");
        }
        if (this.organizationPreferencesAdminFuncionalities.planPayments) {
          funcionalities.push("PLAN_PAYMENTS");
        }
        if (this.organizationPreferencesAdminFuncionalities.planCustomize) {
          funcionalities.push("PLAN_CUSTOMIZE");
        }
        if (this.organizationPreferencesAdminFuncionalities.planInvoice) {
          funcionalities.push("PLAN_INVOICE");
        }
        if (this.organizationPreferencesAdminFuncionalities.planRatings) {
          funcionalities.push("PLAN_RATINGS");
        }
        if (this.organizationPreferencesAdminFuncionalities.planHc) {
          funcionalities.push("PLAN_HC");
        }
        if (this.organizationPreferencesAdminFuncionalities.planPetitioners) {
          funcionalities.push("PLAN_PETITIONERS");
        }
        if (this.organizationPreferencesAdminFuncionalities.planShareFiles) {
          funcionalities.push("PLAN_SHARE_FILES");
        }
        if (this.organizationPreferencesAdminFuncionalities.planPublicPerfil) {
          funcionalities.push("PLAN_PUBLIC_PERFIL");
        }
        if (
          this.organizationPreferencesAdminFuncionalities.planPaymentsPaypal
        ) {
          funcionalities.push("PLAN_PAYMENTS_PAYPAL");
        }
        if (
          this.organizationPreferencesAdminFuncionalities.planPaymentsStripe
        ) {
          funcionalities.push("PLAN_PAYMENTS_STRIPE");
        }
        if (
          this.organizationPreferencesAdminFuncionalities.planPaymentsWallet
        ) {
          funcionalities.push("PLAN_PAYMENTS_WALLET");
        }
      }

      return funcionalities;
    },
    async updatePlanType() {
      let self = this;

      let data = this.planTypeInfo;

      data.functionalities = this.getFuncionalities();

      this.$awn.asyncBlock(
        organizationService.updatePlanType(
          localStorage.getItem("organizationId"),
          this.planTypeInfo
        ),
        (response) => {
          if (response) {
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.organization.preferences.success.title"
              ),
              text: this.$i18n.t(
                "public.components.organization.preferences.success.text"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.updatePlanType",
            module: "component-organization-preferencesAdmin",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId"), planTypeInfo: this.planTypeInfo
            }),
          });
        },
        " "
      );
    },
    async openModalPlanTypeInfo(type) {
      let planType = this.planTypes.find((option) => option.type === type);
      this.planTypeInfo = planType;
      this.$bvModal.show("modal-plan-type-info-admin");
    },
    async updateOrganizationAdminCita() {
      let self = this;

      var data = {
        id: this.id,
        isGalatea: this.organization.isGalatea,
        planPatientWelcome: this.organization.planPatientWelcome,
        planRecorded: this.organization.planRecorded,
        planSendReminderWallet: this.organization.planSendReminderWallet,
        planSendReminderWalletLimit: this.organization.planSendReminderWalletLimit,
        galateaCodeTelesoporte: this.organization.galateaCodeTelesoporte,
        surveyWelcomeTemplate: this.organization.surveyWelcomeTemplate,
        planSurvey: this.organization.planSurvey,
        planInteractive: this.organization.planInteractive,
        planDashboardPicture: this.organization.planDashboardPicture,
        planMulticonference: this.organization.planMulticonference,
        planReminders: this.organization.planReminders,
        planAlerts: this.organization.planAlerts,
        planPayments: this.organization.planPayments,
        planCustomize: this.organization.planCustomize,
        planInvoice: this.organization.planInvoice,
        planRatings: this.organization.planRatings,
        planHc: this.organization.planHc,
        planPetitioners: this.organization.planPetitioners,
        planShareFiles: this.organization.planShareFiles,
        planPublicPerfil: this.organization.planPublicPerfil,
        planPaymentsPaypal: this.organization.planPaymentsPaypal,
        planPaymentsStripe: this.organization.planPaymentsStripe,
        planPaymentsWallet: this.organization.planPaymentsWallet,
      };

      this.$awn.asyncBlock(
        organizationService.updateAdminCita(data),
        (response) => {
          if (response) {
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.organization.preferences.success.title"
              ),
              text: this.$i18n.t(
                "public.components.organization.preferences.success.text"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.updateAdminCita",
            module: "component-organization-preferencesAdmin",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            }),
          });
        },
        " "
      );
    },
    async changePremiumPlanType() {
      let self = this;

      let planType = self.planTypes.find(
        (option) => option.type === self.planType.type
      );

      this.$awn.asyncBlock(
        organizationService.activePlanType(
          localStorage.getItem("organizationId"),
          planType.id
        ),
        (response) => {
          if (response) {
            self.getPlanTypes();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.activePlanType",
            module: "component-organization-preferencesAdmin",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId"),
              planTypeId: planType.id
            }),
          });
        },
        " "
      );
    },
    async getPlanTypes() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.findAllPlanTypeById(
          localStorage.getItem("organizationId")
        ),
        (response) => {
          if (response) {
            self.planTypes = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.findAllPlanTypeById",
            module: "component-organization-preferencesAdmin",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId")
            }),
          });
        },
        " "
      );
    },
  },
  computed: {},
  data() {
    return {
      planTypes: [],
      timeFreePlanInDays: 30,
      planTypeInfo: undefined,
      organizationPreferencesAdminFuncionalities: {},
    };
  },
  components: { PreferencesAdminFuncionalities },
};
</script>